export const Admin = 'Administrator';
export const Superuser = 'Superuser';
export const User = 'User';